import { computed, resolveComponent, openBlock, createBlock, normalizeClass, withCtx, createElementVNode, createCommentVNode, createElementBlock, toDisplayString, normalizeStyle, renderSlot, Fragment, renderList, createTextVNode } from 'vue';
import propTypes from './utils/prop-types';
import { INPUT_EVENT, SHOW_EVENT, HIDE_EVENT } from './utils/constants';
import { createComponent } from './utils/create-component';
import { isFunction } from './utils/validate';
import { addPxUnit } from './utils/format';
import Popup from './popup';
import Icon from './icon';
import Button from './button';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var props = {
  /**
   * 弹窗是否可见
   */
  modelValue: propTypes["boolean"]().def(false),
  /**
   * 窗口标题
   */
  title: propTypes.string(),
  /**
   * 弹窗的内容（用于简单内容，复杂内容请使用slot）支持 HTML
   */
  content: propTypes.string(),
  /**
   * 底部操作按钮组（最多支持两个）
   */
  btns: propTypes.array().def([]),
  /**
   * 是否显示右上角关闭按钮
   */
  closeable: propTypes["boolean"]().def(true),
  /**
   * 弹窗内容行数，超出滚动
   */
  contentRows: propTypes.oneOfType([propTypes.string(), propTypes.number()]).def(11),
  /**
   * 是否有蒙层
   */
  showMask: propTypes["boolean"]().def(true),
  /**
   * 点击蒙层是否可关闭弹窗
   */
  maskCloseable: propTypes["boolean"]().def(true),
  /**
   * 是否禁止滚动穿透
   */
  disableScroll: propTypes["boolean"]().def(true),
  /**
   * 是否将弹窗移动至body节点
   */
  transferDom: propTypes["boolean"]().def(true)
};
var emits = [INPUT_EVENT, SHOW_EVENT, HIDE_EVENT];

var _components;
var _createComponent = createComponent('bottom-panel'),
  create = _createComponent.create,
  className = _createComponent.className;
// 内容区域行高
var CONTENT_LINE_HEIGHT = 23;
var script = create({
  components: (_components = {}, _defineProperty(_components, Popup.name, Popup), _defineProperty(_components, Icon.name, Icon), _defineProperty(_components, Button.name, Button), _components),
  props: props,
  emits: emits,
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
      slots = _ref.slots;
    // 根据 props.modelValue 控制弹窗显示/隐藏
    var show = computed({
      get: function get() {
        return props.modelValue;
      },
      set: function set() {
        return onClose();
      }
    });
    // 内容区域样式
    var contentStyle = computed(function () {
      var maxHeight = +props.contentRows * CONTENT_LINE_HEIGHT;
      return {
        maxHeight: addPxUnit(maxHeight)
      };
    });
    /**
     * @description: button click 底部按钮点击
     * @param {BottomPanelFooterBtn}
     * @return {*}
     */
    function onBtnClick(btn) {
      if (isFunction(btn.handler)) {
        btn.handler();
      } else {
        onClose();
      }
    }
    function onClose() {
      emit(INPUT_EVENT, false);
    }
    function onShow() {
      emit(SHOW_EVENT);
    }
    function onHide() {
      emit(HIDE_EVENT);
    }
    return {
      className: className,
      slots: slots,
      show: show,
      contentStyle: contentStyle,
      onBtnClick: onBtnClick,
      onShow: onShow,
      onHide: onHide
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_sp_button = resolveComponent("sp-button");
  var _component_sp_popup = resolveComponent("sp-popup");
  return openBlock(), createBlock(_component_sp_popup, {
    modelValue: _ctx.show,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.show = $event;
    }),
    "class": normalizeClass(_ctx.className),
    showMask: _ctx.showMask,
    maskCloseable: _ctx.maskCloseable,
    position: "bottom",
    disableScroll: _ctx.disableScroll,
    transferDom: _ctx.transferDom,
    closeable: _ctx.closeable,
    onShow: _ctx.onShow,
    onHide: _ctx.onHide
  }, {
    "default": withCtx(function () {
      return [createElementVNode("div", {
        "class": normalizeClass("".concat(_ctx.className, "__body"))
      }, [createCommentVNode(" 标题 "), _ctx.title ? (openBlock(), createElementBlock("div", {
        key: 0,
        "class": normalizeClass("".concat(_ctx.className, "__body_header"))
      }, toDisplayString(_ctx.title), 3 /* TEXT, CLASS */)) : createCommentVNode("v-if", true), createCommentVNode(" 内容 "), _ctx.content ? (openBlock(), createElementBlock("div", {
        key: 1,
        "class": normalizeClass("".concat(_ctx.className, "__body_content")),
        style: normalizeStyle(_ctx.contentStyle)
      }, toDisplayString(_ctx.content), 7 /* TEXT, CLASS, STYLE */)) : createCommentVNode("v-if", true), createCommentVNode(" 默认 slot "), renderSlot(_ctx.$slots, "default"), createCommentVNode(" 底部按钮 "), _ctx.btns && _ctx.btns.length > 0 ? (openBlock(), createElementBlock("div", {
        key: 2,
        "class": normalizeClass("".concat(_ctx.className, "__body_footer"))
      }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.btns, function (btn, index) {
        return openBlock(), createBlock(_component_sp_button, {
          "class": normalizeClass(["".concat(_ctx.className, "__body_footer_btn"), _defineProperty({}, "".concat(_ctx.className, "__body_footer_btn-padding"), _ctx.btns.length > 1 && index === 0)]),
          key: index,
          type: btn.type,
          style: normalizeStyle({
            width: _ctx.btns.length === 1 && (_ctx.btns[0].type === 'primary' ? '168px' : '256px')
          }),
          size: "large",
          fit: "",
          onClick: function onClick($event) {
            return _ctx.onBtnClick(btn);
          }
        }, {
          "default": withCtx(function () {
            return [createTextVNode(toDisplayString(btn.text), 1 /* TEXT */)];
          }),

          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "type", "style", "onClick"]);
      }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */)) : createCommentVNode("v-if", true)], 2 /* CLASS */)];
    }),

    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["modelValue", "class", "showMask", "maskCloseable", "disableScroll", "transferDom", "closeable", "onShow", "onHide"]);
}

script.render = render;
script.__file = "components/src/component/bottom-panel/bottom-panel.vue";

/*
 * @Description: BottomPanel 底部面板组件导出文件
 * @Author: duqiao@kuaishou.com
 * @Date: 2022-03-31 19:49:08
 * @LastEditors: zhoushichao@kuaishou.com
 * @LastEditTime: 2023-02-02 11:28:48
 */
var _BottomPanel = script;

export { _BottomPanel as default };
